var resize = (function () {

	function setup() {
		$(window).on('resize', function () {
			windowResized();
		});

		window.setTimeout(windowResized, 600);
		windowResized();
	}

	function windowResized() {
		// We need to manually set left margin of blocks that overflow right
		$('.container-oflw-right').each((i, e) => {
			let margin = $(e).parent().find('.pos-container').css('margin-left');
			$(e).css('margin-left', margin);
		});

		// Set height of split backgrounds
		$('.background-wrapper').each((i, e) => {
			let height = $('.container-fluid > .container', e).outerHeight();
			$(e).css('height', height + 'px');
		});
	}

	return {
		init: function () {
			$(function () {
				setup();
			});
		}
	};
})();

export var resize;